// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { RplFavorecido } from './rpl-favorecido.model';
import { RplItem } from './rpl-item.model';

export class RplCotacao extends BaseResourceModel {
  constructor(
    public id?: number,
    public valor_unitario?: number,
    public marca?: string,
    public data_cotacao?: Date,
    public valor_referencia?: number,
    public favorecido?: RplFavorecido,
    public item?: RplItem,
  ) {
    super();
  }

  static converteJson(json: any): RplCotacao {
    return Object.assign(new RplCotacao(), json);
  }
}
